import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-759d9c95")

_pushScopeId("data-v-759d9c95")
const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-center" }
const _hoisted_2 = {
  key: 0,
  class: "table-header p-d-flex"
}
const _hoisted_3 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "kn-overflow-y last-flex-container kn-flex" }
const _hoisted_6 = { "data-test": "document-status" }
const _hoisted_7 = { class: "fa-stack" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye fa-stack-1x" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "fa fa-ban fa-stack-2x"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.searchMode)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            id: "documents-found-hint",
            class: "p-m-2",
            severity: "info",
            closable: false,
            style: _ctx.documentBrowserTableDescriptor.styles.message
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.documents.length + ' ' + _ctx.$t('documentBrowser.documentsFound')), 1)
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.searchMode)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              type: "text",
              placeholder: _ctx.$t('common.search'),
              "data-test": "filterInput"
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_DataTable, {
        id: "documents-datatable",
        first: _ctx.first,
        "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => (_ctx.first = $event)),
        value: _ctx.documents,
        paginator: _ctx.documents.length > _ctx.documentBrowserTableDescriptor.rows,
        paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        currentPageReportTemplate: 
                _ctx.$t('common.table.footer.paginated', {
                    first: '{first}',
                    last: '{last}',
                    totalRecords: '{totalRecords}'
                })
            ,
        rows: _ctx.documentBrowserTableDescriptor.rows,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
        filterDisplay: "menu",
        selectionMode: "single",
        class: "p-datatable-sm kn-table",
        dataKey: "id",
        resizableColumns: true,
        responsiveLayout: _ctx.documentBrowserTableDescriptor.responsiveLayout,
        breakpoint: _ctx.documentBrowserTableDescriptor.breakpoint,
        onRowClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('selected', $event.data))),
        "data-test": "documents-datatable",
        style: {"width":"100%"},
        scrollable: true,
        scrollHeight: "100%"
      }, {
        empty: _withId(() => [
          _createVNode(_component_Message, {
            class: "p-m-2",
            severity: "info",
            closable: false,
            style: _ctx.documentBrowserTableDescriptor.styles.message,
            "data-test": "no-documents-hint"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('documentBrowser.noDocumentsHint')), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentBrowserTableDescriptor.columns, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              class: "kn-truncated",
              style: col.style,
              header: _ctx.$t(col.header),
              field: col.field,
              key: col.field,
              sortField: col.field,
              sortable: true
            }, {
              filter: _withId(({filterModel}) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                  class: "p-column-filter"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              body: _withId((slotProps) => [
                _withDirectives(_createVNode("span", { class: "kn-truncated" }, _toDisplayString(_ctx.getTranslatedValue(slotProps.data[col.field], col.field)), 513), [
                  [
                    _directive_tooltip,
                    slotProps.data[col.field],
                    void 0,
                    { top: true }
                  ]
                ])
              ]),
              _: 2
            }, 1032, ["style", "header", "field", "sortField"]))
          }), 128)),
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                header: _ctx.$t('common.status'),
                field: "stateCodeStr",
                sortField: "stateCodeStr",
                sortable: true,
                style: _ctx.documentBrowserTableDescriptor.table.smallmessage
              }, {
                filter: _withId(({filterModel}) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                    class: "p-column-filter"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                body: _withId((slotProps) => [
                  _createVNode("span", _hoisted_6, _toDisplayString(slotProps.data['stateCodeStr']), 1)
                ]),
                _: 1
              }, 8, ["header", "style"]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 1,
                header: _ctx.$t('common.visible'),
                field: "visible",
                sortField: "visible",
                sortable: true,
                style: _ctx.documentBrowserTableDescriptor.table.iconColumn.style
              }, {
                body: _withId((slotProps) => [
                  _withDirectives(_createVNode("span", _hoisted_7, [
                    _hoisted_8,
                    (!slotProps.data['visible'])
                      ? (_openBlock(), _createBlock("i", _hoisted_9))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_directive_tooltip, slotProps.data['visible'] ? _ctx.$t('common.visible') : _ctx.$t('common.notVisible')]
                  ])
                ]),
                _: 1
              }, 8, ["header", "style"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, {
            style: _ctx.documentBrowserTableDescriptor.table.iconColumn.style
          }, {
            body: _withId((slotProps) => [
              _withDirectives(_createVNode(_component_Button, {
                icon: "fa fa-play-circle",
                class: "p-button-link",
                onClick: _withModifiers(($event: any) => (_ctx.executeDocument(slotProps.data)), ["stop"])
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('documentBrowser.executeDocument'),
                  void 0,
                  { left: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["first", "value", "paginator", "currentPageReportTemplate", "rows", "filters", "responsiveLayout", "breakpoint"])
    ])
  ], 64))
})